import React, { useEffect, useState } from 'react'
import { Row, Col, Form, Button, Card } from 'react-bootstrap'
import { obtenerSede } from './ObtenerSedes'
import { IndicadoresOt, contarEquipos } from './IndicadoresOt'
import { ChartComponent } from './GraficoItemsOt'
import { Modales } from '../Modales'
import { useTheme } from '../../hooks/useTheme'

let indicadores={}
let sedes=[]

const Cabecera = ({ots, selectSede, sedeSeleted, setSitioSeleted, setSedes}) => {
  const [sedeSelect, setSedeSelect] = useState()
  const [estadomodal, setEstadomodal] = useState(false)
  const [DataChart, setDataChart] = useState([])
  const [showChart, setShowChart] = useState(false)
  const { size } = useTheme()
  
  const handleToggleChart = () => {
    const resulta = contarEquipos(ots?.equipos)
    setDataChart(resulta)
    setShowChart(!showChart)
  }

useEffect(() => {
  if (ots?.equipos) {
    indicadores = IndicadoresOt(ots?.equipos)
    sedes = obtenerSede(ots?.equipos)
    setSedes(sedes)
  }
}, [ots])

const handleSelectChange = (e) => {
  if (e.target.value === "todas") {
    selectSede()
    setSedeSelect()
  } else {
    const sedeFilter = sedes.filter((item) => item._id === e.target.value)
    setSedeSelect(sedeFilter[0])
    selectSede(e.target.value)
  } 
}

const handleSelectSitio = (e) => {
  if (e.target.value === "todos") {
    setSitioSeleted()
  } else {
    setSitioSeleted(e.target.value)
  }
}
  return (
    <>
      <Card className="shadow-sm w-100 mb-3">
        <Card.Header className="w-100 bg-primary text-white d-flex align-items-center">
          <strong>
            <i className="bi bi-file-earmark-text me-2"></i>
            Orden de Trabajo {ots?.numeroOrden}-{ots?.visitas}
          </strong>
        </Card.Header>
        <Card.Body className="p-3 w-100">
        <Row>
          {/* Columna Izquierda */}
          <Col xs={12} lg={8} className="border-end p-2">
            <Row>
              <Col xs={12} md={6}>
                {/* Componente de cliente */}
                <div className="mb-0 d-flex align-items-center">
                  <Form.Label className="fw-bold me-2 m-0">Cliente:</Form.Label>
                  <p className="mb-0">{ots?.cliente?.nombre}</p>
                </div>
                <div className="mb-0 d-flex align-items-center">
                  <Form.Label className="fw-bold me-2 m-0">Nit:</Form.Label>
                  <p className="mb-0">{ots?.cliente?.identificacion}</p>
                </div>
                <div className="mb-0 d-flex align-items-center">
                  <Form.Label className="fw-bold me-2 m-0">Ciudad:</Form.Label>
                  <p className="mb-0">{sedeSelect?.ciudad || ots?.cliente?.ciudad}</p>
                </div>
                <div className="mb-0 d-flex align-items-center m-0">
                  <Form.Label className="fw-bold me-2 m-0">Sede:</Form.Label>
                  <p className="mb-0">{sedeSelect?.nameSede || 'Todas'}</p>
                </div>
              </Col>
              <Col xs={12} md={6}>
                {/* Componente de persona de contacto */}
                <div className="mb-0 d-flex align-items-center m-0">
                  <Form.Label className="fw-bold me-2 m-0">Dirección:</Form.Label>
                  <p className="mb-0">{sedeSelect?.dirSede || ots?.cliente?.direccion}</p>
                </div>
                <div className="mb-0 d-flex align-items-center">
                  <Form.Label className="fw-bold me-2 m-0">Contacto:</Form.Label>
                  <p className="mb-0">{sedeSelect?.contSede || ots?.cliente?.contacto}</p>
                </div>
                <div className="mb-0 d-flex align-items-center">
                  <Form.Label className="fw-bold me-2 m-0">Teléfono:</Form.Label>
                  <p className="mb-0">{sedeSelect?.celContacto || ots?.cliente?.telefono}</p>
                </div>
                <div className="mb-0 d-flex align-items-center">
                  <Form.Label className="fw-bold me-2 m-0">Correo:</Form.Label>
                  <p className="mb-0" style={{overflowWrap:'break-word'}}>{ots?.cliente?.correo}</p>
                </div>
              </Col>
              <Col xs={12}>
                <hr className="my-3" />
              </Col>
              {/* Selects */}
              <Col xs={12} md={6}>
                <div className="mb-3 d-flex align-items-center">
                  <Form.Label htmlFor="selectSede" className="fw-bold me-2">Selecciona la sede:</Form.Label>
                  <Form.Select id="selectSede" size={size.width < 768 ? 'sm' : undefined} onChange={handleSelectChange}>
                    {sedes && sedes?.map(sede => (
                      <option key={sede._id} name={sede.nameSede} value={sede._id}>{sede.nameSede}</option>
                    ))}
                    <option value="todas">Todas</option>
                  </Form.Select>
                </div>
              </Col>
              <Col xs={12} md={6}>
                <div className="mb-3 d-flex align-items-center">
                  <Form.Label htmlFor="selectOpciones" className="fw-bold me-2">Lugar de Calibración:</Form.Label>
                  <Form.Select id="selectOpciones" size={size.width < 768 ? 'sm' : undefined} onChange={handleSelectSitio}>
                    <option value="todos">Todos</option>
                    <option value="Sitio">Sitio</option>
                    <option value="Laboratorio">Laboratorio</option>
                  </Form.Select>
                </div>
              </Col>
            </Row>
          </Col>
          {/* Columna Derecha */}
          <Col xs={12} lg={4} className="p-2">
            <h5 className="mb-3">Indicador General</h5>
            <hr/>
            {indicadores?.Finalizados > 0 && (
              <>
                <p className="mb-0">Finalizados</p>
                <div className="progress">
                  <div className="progress-bar bg-success" role="progressbar" style={{ width: `${indicadores?.Finalizados}%` }} aria-valuenow={indicadores?.Finalizados} aria-valuemin="0" aria-valuemax="100">
                    {indicadores?.Finalizados}%
                  </div>
                </div>
              </>
            )}
            {indicadores?.No_finalizados > 0 && (
              <>
                <p className="mb-0">No Finalizados</p>
                <div className="progress">
                  <div className="progress-bar bg-secondary" role="progressbar" style={{ width: `${indicadores?.No_finalizados}%` }} aria-valuenow={indicadores?.No_finalizados} aria-valuemin="0" aria-valuemax="100">
                    {indicadores?.No_finalizados}%
                  </div>
                </div>
              </>
            )}
            {indicadores?.Procesados > 0 && (
              <>
                <p className="mb-0">Procesados</p>
                <div className="progress">
                  <div className="progress-bar bg-info" role="progressbar" style={{ width: `${indicadores?.Procesados}%` }} aria-valuenow={indicadores?.Procesados} aria-valuemin="0" aria-valuemax="100">
                    {indicadores?.Procesados}%
                  </div>
                </div>
              </>
            )}
            {indicadores?.Pendientes > 0 && (
              <>
                <p className="mb-0">Pendientes</p>
                <div className="progress">
                  <div className="progress-bar bg-warning" role="progressbar" style={{ width: `${indicadores?.Pendientes}%` }} aria-valuenow={indicadores?.Pendientes} aria-valuemin="0" aria-valuemax="100">
                    {indicadores?.Pendientes}%
                  </div>
                </div>
              </>
            )}
            {indicadores?.Cancelados > 0 && (
              <>
                <p className="mb-0">Cancelados</p>
                <div className="progress">
                  <div className="progress-bar bg-danger" role="progressbar" style={{ width: `${indicadores?.Cancelados}%` }} aria-valuenow={indicadores?.Cancelados} aria-valuemin="0" aria-valuemax="100">
                    {indicadores?.Cancelados}%
                  </div>
                </div>
              </>
            )}
            {indicadores?.Aprobados > 0 && (
              <>
                <p className="mb-0">Aprobados</p>
                <div className="progress">
                  <div className="progress-bar bg-primary" role="progressbar" style={{ width: `${indicadores?.Aprobados}%` }} aria-valuenow={indicadores?.Aprobados} aria-valuemin="0" aria-valuemax="100">
                    {indicadores?.Aprobados}%
                  </div>
                </div>
              </>
            )}
            <hr/>
            <div>
              {/* Indicadores y enlace "Ver más" */}
              <a className="cursor-p" onClick={handleToggleChart}>
                {showChart ? 'Ver menos' : 'Ver más'}
              </a>
            </div>
          </Col>
        </Row>
        </Card.Body>
      </Card>
      {size.width >= 768 && showChart && <ChartComponent data={DataChart} />}
    </>
  )
}

export default Cabecera